export default __webpack_public_path__ + "static/media/20.ed55e219.gif";